import {
    Component,
    Output,
    EventEmitter
} from '@angular/core';

@Component({
    selector: 'app-tips',
    templateUrl: './tips.component.pug',
    styleUrls: ['./tips.component.less']
})
export class TipsComponent {

    @Output() continue: EventEmitter<any> = new EventEmitter();
    @Output() cancel: EventEmitter<any> = new EventEmitter();
    @Output() close: EventEmitter<any> = new EventEmitter();

    constructor(
    ) {
    }

    onContinue() {
        this.continue.emit();
    }

    onCancel() {
        this.cancel.emit();
    }

    onClose() {
        this.close.emit();
    }
}
